import { createSelector } from '@reduxjs/toolkit';
import { filteredCruisePackagesSelector } from './filterSelectors';
import { CRUISE_LIST_SORT_ORDERS } from '../../../constants/sortOrders';

const selectedSortOrder = (state) => state.sort.selected;

const sortByPriceDesc = (a, b) => {
  return b.cruiseSortAndFilterValues.totalPrice - a.cruiseSortAndFilterValues.totalPrice;
};

const sortByPriceAsc = (a, b) => {
  return a.cruiseSortAndFilterValues.totalPrice - b.cruiseSortAndFilterValues.totalPrice;
};

const sortByDepartureDate = (a, b) => {
  let delta = a.cruiseSortAndFilterValues.departureDate - b.cruiseSortAndFilterValues.departureDate;

  if (delta === 0) {
    delta = a.cruiseSortAndFilterValues.totalPrice - b.cruiseSortAndFilterValues.totalPrice;
  }

  return delta;
};

const sortByDuration = (a, b) => {
  let delta = a.cruiseSortAndFilterValues.duration - b.cruiseSortAndFilterValues.duration;

  if (delta === 0) {
    delta = a.cruiseSortAndFilterValues.totalPrice - b.cruiseSortAndFilterValues.totalPrice;
  }

  return delta;
};

// **Sort a copy, never the input.** `Array.prototype.sort` reorders in place, and this array is
// the one the store holds — which immer has frozen, so an in-place sort throws from inside the
// selector on the first render. immer's auto-freeze is on in production as well as development.
export const sortedCruiseListSelector = createSelector(
  [filteredCruisePackagesSelector, selectedSortOrder],
  (filteredCruiseList, sortOrder) => {
    if (filteredCruiseList == null) {
      return null;
    }

    let sortedCruiseList = [];
    switch (sortOrder) {
      case CRUISE_LIST_SORT_ORDERS.DEPARTURE_DATE:
        sortedCruiseList = [...filteredCruiseList].sort(sortByDepartureDate);
        break;
      case CRUISE_LIST_SORT_ORDERS.LOWEST_PRICE:
        sortedCruiseList = [...filteredCruiseList].sort(sortByPriceAsc);
        break;
      case CRUISE_LIST_SORT_ORDERS.HIGHEST_PRICE:
        sortedCruiseList = [...filteredCruiseList].sort(sortByPriceDesc);
        break;
      case CRUISE_LIST_SORT_ORDERS.DURATION:
        sortedCruiseList = [...filteredCruiseList].sort(sortByDuration);
        break;
      default:
        sortedCruiseList = filteredCruiseList;
        break;
    }
    return sortedCruiseList;
  },
);
